import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface ILinkProps {
  text: string;
  href?: string;
  onClick?: () => void;
}

export const HelpMenuLink = ({ text, href, onClick }: ILinkProps) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    onClick?.();
    if (href) {
      navigate(href);
    }
  };

  return (
    <button
      type="button"
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        width: 'fit-content',
      }}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Typography as="span" color={isHovered ? colors.neutral[300] : colors.neutral[600]} size="body_large" bold>
        {text}
      </Typography>
    </button>
  );
};
